import AddressRepository from './AddressRepository'
import AuthRepository from './AuthRepository'
import UserRepository from './UserRepository'
import RoleRepository from './RoleRepository'
import DepartmentRepository from './DepartmentRepository'
import ProductRepository from './ProductRepository'
import ProductGroupRepository from './ProductGroupRepository'
import ImageRepository from './ImageRepository'
import ScheduleRepository from './ScheduleRepository'
import ContactRepository from './ContactRepository'
import ContactSourceRepository from './ContactSourceRepository'
import ContactStatusRepository from './ContactStatusRepository'
import ComboRepository from './ComboRepository'
import KpiRepository from './KpiRepository'
import NotificationRepository from './NotificationRepository'
import AppointmentRespository from './AppointmentRespository'
import CallCenterRespository from './CallCenterRespository'
import OrderRepository from './OrderRepository'
import SettingRepository from './SettingRepository'
import ReportRepository from './ReportRepository'
import SupportRepository from './SupportRepository'
import SmsRepository from "@/repositories/SmsRepository";
import CustomerFileRepository from "@/repositories/CustomerFileRepository";
import SiteRepository from './SiteRepository'
import AnnouncementRepository from './AnnouncementRepository'
import SchoolLevelRepository from './SchoolLevelRepository'
import StoreRepository from "@/repositories/StoreRepository"
import TrainingRepository from './trainingRepository'
import CoreActionsLog from './CoreActionLogRepository'
import SubjectRepository from './SubjectRepository'
import DashboardPartner from './DashboardPartnerRepository'
import organizationMachine from './organizationMachineRepository'
import IndicatorRepository from './IndicatorReponsitory'
import TypeRepository from './TypeRepository'
import TestManageRepository from './TestManageRepository'
import AllotmentRepository from './AllotmentRepository'
import ZaloContactRepository from './ZaloContactRepository'
import ChatbotRepository from './ChatbotRepository'
import TutorTestRepository from './TutorTestRepository';
import AgencyRepository from './AgencyRepository';
import ScriptRepository from './ScriptRepository'
import ExamRepository from './ExamRepository'
import SchoolRespository from "@/repositories/SchoolRespository";
import ProgramRepository from "@/repositories/ProgramRepository";
import PrioritySettingRepository from "./PrioritySettingRepository";
import HoldContactSettingRepository from "./HoldContactSettingRepository";
import LogRepository from "@/repositories/LogRepository";
import ShortLinkRepository from './ShortLinkRepository';
import TicketRepository from "@/repositories/TicketRepository";
import ConfigErpRepository from "@/repositories/ConfigErpRepository";
import PaymentQRCodeRepository from './PaymentQRCodeRepository';
import POSNotificationRepository from './POSNotificationRepository';

const repositories = {
  log: LogRepository,
  address: AddressRepository,
  auth: AuthRepository,
  user: UserRepository,
  role: RoleRepository,
  department: DepartmentRepository,
  product: ProductRepository,
  product_group: ProductGroupRepository,
  image: ImageRepository,
  schedule: ScheduleRepository,
  contact: ContactRepository,
  contact_source: ContactSourceRepository,
  contact_status: ContactStatusRepository,
  combo: ComboRepository,
  kpi: KpiRepository,
  notification: NotificationRepository,
  appointment: AppointmentRespository,
  call_center: CallCenterRespository,
  order: OrderRepository,
  setting: SettingRepository,
  report: ReportRepository,
  sms: SmsRepository,
  customer_file: CustomerFileRepository,
  support: SupportRepository,
  site: SiteRepository,
  announcement: AnnouncementRepository,
  school_level: SchoolLevelRepository,
  core_actions_log: CoreActionsLog,
  store: StoreRepository,
  training: TrainingRepository,
  subject: SubjectRepository,
  dashboard_partner: DashboardPartner,
  organization_machine: organizationMachine,
  indicator: IndicatorRepository,
  type: TypeRepository,
  testManage: TestManageRepository,
  allotment: AllotmentRepository,
  zalo: ZaloContactRepository,
  chatbot: ChatbotRepository,
  tutorTest:  TutorTestRepository,
  agency: AgencyRepository,
  script: ScriptRepository,
  exam: ExamRepository,
  school: SchoolRespository,
  program : ProgramRepository,
  priority_setting: PrioritySettingRepository,
  hold_contact_setting: HoldContactSettingRepository,
  short_link: ShortLinkRepository,
  ticket: TicketRepository,
  configErp: ConfigErpRepository,
  pos: PaymentQRCodeRepository,
  posNotification: POSNotificationRepository,
};

export default {
  get: (name) => repositories[name],
};
